<script lang="ts">
    import { getWeather } from "@/Util/utils";
    import { MedianAndWeatherStores } from "./stores";
    export let trainingMedians: Object

    const stores = new MedianAndWeatherStores(trainingMedians)

    getWeather((weather, hasSucceeded) => {
        if (!hasSucceeded) console.error('Failed to get weather')
        stores.locationPermission.set(hasSucceeded)
        stores.weather.set(hasSucceeded ? weather : null)
    })
    
    export const getStores = () => stores
</script>